export const SET_ATTACHMENTS_ERROR = 'SET_ATTACHMENTS_ERROR';
export const SET_ATTACHMENTS_LIST = 'SET_ATTACHMENTS_LIST';
export const SET_TOTAL_AMOUNT_OF_ATTACHMENTS = 'SET_TOTAL_AMOUNT_OF_ATTACHMENTS';
export const SET_FETCHING_ATTACHMENTS = 'SET_FETCHING_ATTACHMENTS';
export const SET_ATTACHMENTS_SHOW_MODAL = 'SET_ATTACHMENTS_SHOW_MODAL';
export const SET_ATTACHMENTS_ADD_ERROR = 'SET_ATTACHMENTS_ADD_ERROR';
export const SET_ATTACHMENTS_ADD_SUCCESS = 'SET_ATTACHMENTS_ADD_SUCCESS';
export const SET_ATTACHMENTS_ADD_FETCHING = 'SET_ATTACHMENTS_ADD_FETCHING';
